import { render, staticRenderFns } from "./erelatedapp.vue?vue&type=template&id=21d9bd6f&scoped=true&"
import script from "./erelatedapp.vue?vue&type=script&lang=js&"
export * from "./erelatedapp.vue?vue&type=script&lang=js&"
import style0 from "./erelatedapp.vue?vue&type=style&index=0&id=21d9bd6f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d9bd6f",
  null
  
)

export default component.exports